import $ from 'jquery';
import InlineVideo from '../../components/inline-video';
import ResponsiveVideo from '../../components/responsive-video';
import RevealWhenVisible from '../../components/reveal-when-visible';
import SingleProductAddToCart from '../seletti/components/single-product-add-to-cart';
$(() => {
    RevealWhenVisible.init();
    InlineVideo.init();
    ResponsiveVideo.init();
    SingleProductAddToCart.init();
});
